import SwiperCore, {
  Autoplay,
  Grid,
  Navigation,
  Pagination,
  Scrollbar,
} from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import SingleProduct from "../ecommerce/singleProduct/SingleProduct";
import { RecommendedSliderWrapper } from "./cart-styles";
import { useState } from "react";
SwiperCore.use([Navigation, Autoplay, Scrollbar, Pagination, Grid]);

const RecomSlider = ({ relatedProducts }) => {
  const [recomSwiper, setRecomSwiper] = useState(null);
  return (
    <RecommendedSliderWrapper>
      <Swiper
        spaceBetween={20}
        navigation={{
          prevEl: ".custom_prev_rl",
          nextEl: ".custom_next_rl",
        }}
        className=""
        slidesPerView={2}
        slidesPerGroup={2}
        breakpoints={{
          575: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          768: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          992: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
          1440: {
            slidesPerView: 3,
            slidesPerGroup: 3,
          },
        }}
        onSwiper={(swiper) => setRecomSwiper(swiper)}
        onSlideChange={(swiper) =>
          setRecomSwiper({
            ...recomSwiper,
            realIndex: swiper.realIndex,
          })
        }
        initialSlide={0}
        scrollbar
      >
        {relatedProducts &&
          relatedProducts.map((item, itemIdx) => (
            <SwiperSlide key={itemIdx}>
              <SingleProduct product={item} />
            </SwiperSlide>
          ))}
      </Swiper>
      <div className="slider_nav">
        <span
          className="custom_prev_rl"
          style={{
            visibility:
              recomSwiper && recomSwiper?.realIndex == 0 ? "hidden" : "visible",
          }}
        >
          <i className="fi-rs-arrow-small-left"></i>
        </span>
        <span
          className="custom_next_rl"
          style={{
            visibility:
              recomSwiper &&
              recomSwiper?.realIndex +
                (Number(recomSwiper?.currentBreakpoint) < 992 ? 2 : 3) >=
                relatedProducts?.length
                ? "hidden"
                : "visible",
          }}
        >
          <i className="fi-rs-arrow-small-right"></i>
        </span>
      </div>
    </RecommendedSliderWrapper>
  );
};
export default RecomSlider;
